import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import '../Style/AddEmployee.css';
import axios from "axios";
import { FileText, UploadCloud, X, Eye } from 'lucide-react';
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const DocumentsList = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [members, setMembers] = useState([]); 
  const [selectedUnit, setSelectedUnit] = useState(null);

  const navigate = useNavigate(); // ✅ Must be top-level hook

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const token = localStorage.getItem("token");
        const society = localStorage.getItem("society");
        if (!token || !society) return;

        const resp = await axios.get(
          `${BASE_URL}/api/member/get-list?society=${encodeURIComponent(society)}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setMembers(resp.data || []);
      } catch (err) {
        console.error("fetch members error:", err);
      }
    };
    fetchMembers();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadProgress(0);

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => setPreviewUrl(reader.result);
        reader.readAsDataURL(file);
      } else {
        setPreviewUrl(null);
      }
    }
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer position="bottom-right" autoClose={3000} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <main className="content-area">
          <SubHeader />

          <div className="premium-form-container">
            <div className="premium-card" style={{ padding: '2rem', maxWidth: '500px', margin: 'auto' }}>
              
              {/* Header with Eye icon to navigate */}
              <div className="card-header-premium" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h2 style={{ color: "#007BFF" }}>Upload Documents</h2>
              <Eye
                size={24}
                color="#4a90e2"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/documents-list")} // ✅ Navigates to the view page
                />
              </div>

              {/* Select Unit */}
              <div style={{ marginBottom: '1rem' }}>
                <label>Select Unit:</label>
                <Select
                  options={members.map(m => ({ value: m.unit_no, label: `${m.unit_no} - ${m.member_name}` }))}
                  value={selectedUnit}
                  onChange={setSelectedUnit}
                  placeholder="Select unit..."
                  isSearchable
                  styles={{
                    control: (provided) => ({ ...provided, borderRadius: "6px", borderColor: "#ccc", minHeight: "40px" }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 })
                  }}
                />
              </div>

              {/* File upload */}
              <div
                className="upload-section"
                style={{ border: "2px dashed #4a90e2", borderRadius: "10px", padding: "1.5rem", textAlign: "center", cursor: "pointer", transition: "0.3s", background: "#f9f9f9" }}
                onClick={() => document.getElementById("fileInput").click()}
              >
                <UploadCloud size={50} color="#4a90e2" />
                <p style={{ marginTop: '10px' }}>Click or drag file to upload</p>
                <input type="file" id="fileInput" style={{ display: "none" }} accept="image/*,application/pdf" onChange={handleFileChange} />
              </div>

              {/* File preview */}

              {/* Upload progress */}
              {uploadProgress > 0 && (
                <div style={{ marginTop: '1rem', background: '#eee', borderRadius: '8px', overflow: 'hidden' }}>
                  <div style={{ width: `${uploadProgress}%`, height: '10px', backgroundColor: '#4a90e2', transition: 'width 0.3s' }} />
                  <p style={{ textAlign: 'right', margin: '5px 0 0 0', fontSize: '0.9rem' }}>{uploadProgress}%</p>
                </div>
              )}

              <button
                className="upload-btn"
                disabled={!selectedUnit || !selectedFile}
                style={{ marginTop: '1rem', width: '100%', padding: '0.75rem', backgroundColor: '#4a90e2', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', transition: '0.3s', opacity: (!selectedUnit || !selectedFile) ? 0.6 : 1 }}
              >
                Upload
              </button>
            </div>
          </div>

        </main>
      </div>
    </div>
  );
};

export default DocumentsList;
